<template>
  <section class="page-view about">
    <div class="banner02">
      <img src="/static/images/gisagro4.0/banner-about.gif" />
      <div class="text">
        <img src="/static/images/gisagro4.0/logo-gistda.png" />
        <label>
          สำนักงานพัฒนาเทคโนโลยีอวกาศและภูมิสารสนเทศ (องค์การมหาชน)
        </label>
      </div>
    </div>
    <div style="padding:8px 10px">
      <div class="title center">
        ประวัติความเป็นมาของโครงการ
      </div>
      <p style="text-indent:50px">
        สำนักงานพัฒนาเทคโนโลยีอวกาศและภูมิสารสนเทศ (องค์การมหาชน) : สทอภ. หรือ 
        Geo-Informatics and Space Technology Development Agency (Public Organization) : GISTDA 
        เป็นหน่วยงานของรัฐในรูปแบบองค์การมหาชน ภายใต้กำกับดูแลของรัฐมนตรีว่าการกระทรวงวิทยาศาสตร์และเทคโนโลยี
        จัดตั้งโดยมีวัตถุประสงค์เพื่อพัฒนาเทคโนโลยีอวกาศ และภูมิสารสนเทศให้เป็นความรู้ไร้พรมแดน 
        เพื่อเป็นประโยชน์ต่อการพัฒนาประเทศ มุ่งเน้นการบริหาร และดำเนินงานอย่างมีประสิทธิภาพ 
        เพื่อบริการข้อมูลภูมิสารสนเทศ บริการวิชาการต่าง ๆ ตลอดจนการวิจัย 
        และพัฒนาเทคโนโลยีอวกาศให้เป็นประโยชน์ต่อประชาชน
      </p>
      <p style="text-indent:50px">
        ในการนี้ สอทภ. ได้จัดทำ <font color="#8f0222">"ระบบบริการภูมิสารสนเทศเพื่อการเกษตร GISagro"</font>
        โดยบูรณาการข้อมูลและความร่วมมือระหว่างหน่วยงานที่เกี่ยวข้อง เพื่อพัฒนาระบบภูมิสารสนเทศที่แสดงสภาพการใช้ประโยชน์ที่ดินด้านการเกษตร 
        การถือครองพื้นที่ การถ่ายทอดเทคโนโลยีเพื่อการเพาะปลูกและเพิ่มผลผลิต รวมทั้งการคาดการณ์ด้านภัยธรรมชาติ โดยใช้ข้อมูลจากดาวเทียม 
        ร่วมกับข้อมูลสำรวจจากพื้นที่ี พัฒนาเป็นระบบบริการจัดการด้านเกษตรที่สนับสนุนให้เกษตรกรสามารถทำการเกษตรได้ประสบความสำเร็จตรงกับความต้องการของตลาด 
        และพัฒนาคุณภาพชีวิตความเป็นอยู่ให้ดีขึ้น
      </p>
      <div class="title center">
        เกี่ยวกับสำนักประยุกต์และบริการภูมิสารสนเทศ
      </div>
      <div>
        <p><u>ภารกิจ</u></p>
        <ul style="list-style:decimal outside none">
          <li>
          จัดหา พัฒนา เผยแพร่ และให้บริการข้อมูลดาวเทียมและข้อมูลภูมิสารสนเทศที่ได้มาตรฐาน 
          เพื่อการใช้ประโยชน์ในเชิงสาธารณะและเชิงธุรกิจ ทั้งภายในและภายนอกองค์กร
          </li>
          <li>
          พัฒนาและให้บริการต้นแบบ แบบจำลอง และข้อมูลจากการศึกษาวิเคราะห์ 
          เพื่อสนับสนุนการใช้ประโยชน์ข้อมูลดาวเทียมและภูมิสารสนเทศเพื่อการบริหารจัดการทรัพยากรธรรมชาติ สิ่งแวดล้อม ภัยพิบัติ 
          เศรษฐกิจ สังคม ความมั่นคงและคุณภาพชีวิต ทั้งในและนอกประเทศ Total Solution, Function Based, Area Based 
          และเฉพาะด้านตามนโยบายรัฐบาล ทั้งในและนอกประเทศ
          </li>
          <li>
          จัดหา พัฒนาเครื่องมือ อุปกรณ์ ระบบ ชุดข้อมูลที่เกี่ยวข้อง เทคนิควิธี และกระบวนการอื่นๆ 
          ที่จำเป็นต่อการบริการภูมิสารสนเทศประยุกต์ทั้งในระดับภาพกว้างและระดับพื้นที่
          </li>
          <li>
          บริการคำปรึกษา ผู้เชี่ยวชาญ รวมทั้งการดูแลรักษาและปรับปรุงฐานข้อมูล และการวิเคราะห์เชิงพื้นที่แก่หน่วยงานภาครัฐ 
          และเอกชน เพื่อผลักดันให้เกิดการใช้ประโยชน์ข้อมูลในการพัฒนาประเทศ
          </li>
        </ul>
        <!--
        <p><u>โครงสร้างสำนักประยุกต์และบริการภูมิสารสนเทศ</u></p>
        <ul style="margin:0px;padding:0px 0px 10px 55px;list-style:decimal outside none">
          <li>
          งานบริหารทั่วไป
          </li>
          <li>
          ฝ่ายบริการผลิตภัณฑ์: วิเคราะห์และให้บริการผลิตภัณฑ์ข้อมูลดาวเทียม ข้อมูลภูมิสารสนเทศ และ Solution เพื่อสนับสนุนการใช้
          ประโยชน์ข้อมูลในด้านเศรษฐกิจ สังคม สิ่งแวดล้อม ทรัพยากรธรรมชาติ และการป้องกันภัยพิบัติ
          </li>
          <li>
          ฝ่ายสิ่งแวดล้อมและภัยพิบัติ: เฝ้าระวัง ติดตาม และคาดการณ์สถานการณ์ด้านสิ่งแวดล้อม การเปลี่ยนแปลงภูมิอากาศและภัยพิบัติ 
          การจัดทำฐานข้อมูลแผนที่พื้นที่เสี่ยงภัย พื้นที่ประสบภัย และพื้นที่ที่ได้รับผลกระทบ รวมทั้งการพัฒนาการให้บริการเพื่อตรวจสอบ
          สถานการณ์ภัยพิบัติต่างๆ
          </li>
          <li>
          ฝ่ายทรัพยากรธรรมชาติ: จัดทำและพัฒนาข้อมูลภูมิสารสนเทศ ด้านทรัพยากรธรรมชาติ ทั้งทางบก ทางทะเลและชายฝั่ง รวมทั้ง
          การติดตาม เฝ้าระวังและคาดการณ์สถานการณ์ ด้านทรัพยากรธรรมชาติ และการดำเนินการวิเคราะห์ ประมวลผล จัดทำแผนที่และ
          รายงาน เพื่อใช้ในการจัดการทรัพยากรธรรมชาติทั้งในระดับประเทศและระดับท้องถิ่น 
          </li>
          <li>
          ฝ่ายเศรษฐกิจ: จัดทำแผนที่พื้นที่เพาะปลูกพืชเศรษฐกิจที่สำคัญรายแปลงพร้อมจัดทำทะเบียนเกษตรกร  การจัดทำฐานข้อมูลที่ตั้ง
          โรงงารอุตสาหกรรมการเกษตร ระบบการคมนาคมขนส่ง รวมถึงชั้นข้อมูลอื่นๆ  ที่เกี่ยวข้องด้านการวางแผนพื้นที่การเพาะปลูกพืช
          เศรษฐกกิจที่สำคัญ ( Zoning ) และการพัฒนาระบบบริการภูมิสารสนเทศเพื่อการเกษตร ( Gisagro ) 
          </li>
          <li>
          ฝ่ายภูมิสังคม: จัดทำและพัฒนาข้อมูลเพื่อบริการด้านสังคม ความมั่นคง วัฒนธรรม โบราณคดี การท่องเที่ยว ผังเมือง การพัฒนาชุมชน
          การสนับสนุนโครงการอันเนื่องมาจากพระราชดำริ รวมทั้งการศึกษาและสาธารณสุข
          </li>
        </ul>-->
        <p><u>ผู้อำนวยการ</u></p>
        <ul>
          นางศิริลักษณ์ พฤกษ์ปิติกุล
        </ul>
        <p><u>กิจกรรม/โครงการที่สำคัญ</u></p>
        <ul>
          การให้บริการระบบข้อมูลภูมิสารสนเทศผ่านเครือข่าย
        </ul>
        <ul class="dashed">
          <li>
            ระบบติดตามสถานการณ์การเพาะปลูกพืชเศรษฐกิจของประเทศไทยจากข้อมูลดาวเทียม (Eco-Plant)<br/>
            <a href="https://gisagro.gistda.or.th/ecoplant" target="_blank">
              https://gisagro.gistda.or.th/ecoplant
            </a>
          </li>
          <li>
            ติดตามสถานการณ์น้ำและบริหารจัดการน้ำอย่างยั่งยืน (Thailand Flood Monitoring System)<br/>
            <a href="http://flood.gistda.or.th" target="_blank">
              http://flood.gistda.or.th
            </a>
          </li>
          <li>
            ระบบติดตามภัยแล้งและไฟป่าประเทศไทย (Thailand Fire and Drought Monitoring System)<br/>
            <a href="http://drought.gistda.or.th" target="_blank">
              http://drought.gistda.or.th
            </a>
          </li>
          <li>
            ระบบเรดาร์ชายฝั่ง<br/>
            <a href="http://coastalradar.gistda.or.th" target="_blank">
              http://coastalradar.gistda.or.th
            </a>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
export default {
}
</script>

<style>
.about ul {
  margin: 0px;
  padding: 0px 0px 10px 55px;
}
.about ul.dashed {
  list-style-type: none;
}
.about ul.dashed > li:before {
  content: "-";
  font-weight: bold;
  margin-left: -12px;
}
</style>

